/* -------------------- DRAWERS -------------------- */

// MENU DRAWER
$(document).on("click", "#drawer-toggle", function () {
  $('#menu-drawer').addClass('open');
  $('.custom_overlay').addClass('active');
});

$(document).on("click", "#drawer-close", function () {
  $('#menu-drawer').removeClass('open');
  $('.custom_overlay').removeClass('active');
});

// CART DRAWER
$(document).on("click", "#cart-toggle, .custom-cart-icon", function () {
  $('#cart-drawer').addClass('open');
  $('.custom_overlay2').addClass('active');
});

$(document).on("click", "#cart-close,.cart_empty_button", function () {
  $('#cart-drawer').removeClass('open');
  $('.custom_overlay2').removeClass('active');
});

// GLOBAL CLICK OUTSIDE (single handler)
$(document).on("click", function (e) {
  if (!$(e.target).closest('#menu-drawer, #drawer-toggle').length) {
    $('#menu-drawer').removeClass('open');
    $('.custom_overlay').removeClass('active');
  }

  if (!$(e.target).closest('#cart-drawer, #cart-toggle, .custom-cart-icon,.el-cart-button').length) {
    $('#cart-drawer').removeClass('open');
    $('.custom_overlay2').removeClass('active');
  }
});

/* -------------------- MENU -------------------- */

$(document).on('click', '.drawer-menu-item.has-children > .parent-link', function(e) {
  e.preventDefault();
  $(this).siblings('.sub-menu').addClass('open');
});

$(document).on('click', '.sub-menu .back-btn a', function(e) {
  e.preventDefault();
  $(this).closest('.sub-menu').removeClass('open');
});

/* -------------------- CART HELPERS -------------------- */

function updateCartCount(){
  $.getJSON('/cart.js', function(cart){
    $('.custom-cart-icon .cart-count, .el-cart-count').text(cart.item_count);
  });
}

function refreshCartDrawer() {
  return $.ajax({
    url: window.location.pathname,
    type: 'GET',
    dataType: 'html',
    success: function (data) {
      const $newDrawer = $(data).find('#cart_drawer_content');
      $('#cart_drawer_content').replaceWith($newDrawer);
      updateCartCount();
    }
  });
}

function updateCart(variantId, quantity, key, sellingPlan = null) {
  return $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: JSON.stringify({
      id: key,
      quantity: quantity,
      selling_plan: sellingPlan || null
    }),
    contentType: 'application/json',
    dataType: 'json'
  });
}

/* -------------------- QUANTITY -------------------- */

$(document).on('click', '.quantity_plus, .quantity_minus', function () {
  const $drawer = $('#cart_drawer_content').addClass('loading_hk');
  const $wrap = $(this).closest('.cart_quantity_wrapper');
  const $input = $wrap.find('input[name="quantity_single"]');

  let qty = parseInt($input.val()) || 0;

  if ($(this).hasClass('quantity_plus')) qty++;
  else qty = Math.max(0, qty - 1);

  $input.val(qty);

  updateCart(null, qty, $input.attr('key'), $input.attr('selling_plan'))
    .then(onCartUpdated)
    .finally(() => $drawer.removeClass('loading_hk'));
});

/* -------------------- REMOVE -------------------- */

$(document).on('click', '.cart_item_single_right_remove', function () {
  const $drawer = $('#cart_drawer_content').addClass('loading_hk');
  const key = $(this).attr('key');

  updateCart(null, 0, key)
    .then(onCartUpdated)
    .finally(() => $drawer.removeClass('loading_hk'));
});

/* -------------------- RECOMMENDED PRODUCT -------------------- */

$(document).on("click", ".recommended_product_button", function(e) {
  e.preventDefault();

  const $btn = $(this).addClass("loading_hk");

  $.post("/cart/add.js", {
    quantity: $btn.attr("quantity"),
    id: $btn.attr("variant_id"),
    selling_plan: $btn.attr("selling_plan")
  }, function() {
    onCartUpdated();
    $("#cart-drawer").removeClass("is_empty").addClass("open");
    $btn.removeClass("loading_hk");
  });
});

/* -------------------- SHIPPING PROTECTION -------------------- */

$(document).on("click", ".shipping_protection_flex", function (e) {
  e.preventDefault();

  const $btn = $(this).find('.shipping_protection_add').toggleClass('active');
  const $drawer = $('#cart_drawer_content').addClass('loading_hk');

  if ($btn.hasClass('active')) {
    $.post('/cart/add.js', {
      id: $btn.attr('variant_id'),
      quantity: 1
    }).then(onCartUpdated)
      .finally(() => $drawer.removeClass('loading_hk'));
  } else {
    $('.cart_item_single img[alt="Shipping Protection"]')
      .closest('.cart_item_single')
      .find('.cart_item_single_right_remove')
      .trigger('click');
  }
});

/* -------------------- REPL0 FIX -------------------- */

document.addEventListener("click", function(e){

  const btn = e.target.closest("[data-replo-add-product-variant-to-cart]");
  if(!btn) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const form = btn.closest("[data-replo-product-container]").querySelector("form");
  const formData = new FormData(form);

  fetch("/cart/add.js", {
    method: "POST",
    body: formData
  })
  .then(() => {
    onCartUpdated();
    $('#cart-drawer').addClass('open');
    $('.custom_overlay2').addClass('active');
  });

}, true);

/* -------------------- SUBSCRIPTION TOGGLE -------------------- */

$(document).on("click", ".subscription_toggle", function () {

  const $el = $(this);
  const $item = $el.closest(".cart_item_single");
  const $drawer = $('#cart_drawer_content').addClass('loading_hk');

  const payload = {
    id: $item.data("key"),
    quantity: parseInt($item.find("input").val()),
    selling_plan: $el.data("selling-plan") ? null : $el.data("default-selling-plan")
  };

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    contentType: "application/json",
    data: JSON.stringify(payload)
  }).then(onCartUpdated)
    .finally(() => $drawer.removeClass('loading_hk'));
});

/* -------------------- FREE GIFT -------------------- */

const FREE_VARIANT = 57431390355840;

let isUpdatingFreeGifts = false;

function checkSubscriptionAndFreeProduct() {

  if (isUpdatingFreeGifts) return;

  isUpdatingFreeGifts = true;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      const $drawer = $('#cart_drawer_content');

      /* Find the free gift */
      const freeGift = cart.items.find(
        item => item.variant_id === FREE_VARIANT
      );

      /*
       * Count subscription quantity.
       *
       * Only count normal products that have a selling plan.
       * FREE_VARIANT itself is excluded.
       */
      const subscriptionQuantity = cart.items.reduce((total, item) => {

        if (item.variant_id === FREE_VARIANT) {
          return total;
        }

        if (item.selling_plan_allocation) {
          return total + item.quantity;
        }

        return total;

      }, 0);

      /*
       * FREE_VARIANT should exist ONLY when
       * there are exactly 2 subscription units.
       */
      const shouldHaveFreeGift = subscriptionQuantity >= 1;

      let promises = [];

      /* ---------- ADD FREE GIFT ---------- */

      if (shouldHaveFreeGift && !freeGift) {

        promises.push(
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: FREE_VARIANT,
              quantity: 1
            })
          })
        );

      }

      /* ---------- REMOVE FREE GIFT ---------- */

      if (!shouldHaveFreeGift && freeGift) {

        promises.push(
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: freeGift.key,
              quantity: 0
            })
          })
        );

      }

      /* ---------- UPDATE CART ---------- */

      if (promises.length) {

        $drawer.addClass('loading_hk');

        Promise.all(promises)
          .then(onCartUpdated)
          .finally(() => {

            $drawer.removeClass('loading_hk');

            isUpdatingFreeGifts = false;

          });

      } else {

        isUpdatingFreeGifts = false;

      }

    })
    .catch(() => {

      isUpdatingFreeGifts = false;

    });
}



/* -------------------- CENTRAL CART UPDATE -------------------- */

function onCartUpdated() {
  refreshCartDrawer().then(() => {
    checkSubscriptionAndFreeProduct(); 
    updateCartSellingPlans();
  });
}

/* -------------------- INIT -------------------- */

document.addEventListener('DOMContentLoaded', function () {
  checkSubscriptionAndFreeProduct();
});

/* -------------------- VH FIX -------------------- */

function updateVh() {
  document.documentElement.style.setProperty('--real-vh', `${window.innerHeight}px`);
}
window.addEventListener('resize', updateVh);
window.addEventListener('load', updateVh);




function updateCartSellingPlans() {
  const planRules = {
    // Product 1
    '15953135468928': {
      one: {
        4: 739120513408,
        8: 739120546176,
        12: 739120578944
      },
      moreThanOne: {
        4: 739120415104,
        8: 739120447872,
        12: 739120480640
      }
    },

    // Product 2
    '15905933656448': {
      one: {
        4: 739062251904,
        8: 739062284672,
        12: 739062317440
      },
      moreThanOne: {
        4: 739059728768,
        8: 739059761536,
        12: 739059827072
      }
    }
  };

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {

      const updates = [];

      cart.items.forEach(item => {

        const productKey = String(item.product_id);
        console.log(productKey);
        const rules = planRules[productKey];

        if (!rules) return;

        // Get the currently selected selling plan
        const currentSellingPlan = item.selling_plan_allocation?.selling_plan?.id;

        if (!currentSellingPlan) return;

        /*
         * Detect frequency from current selling plan.
         *
         * We use the existing plan to determine whether
         * this is 4, 8 or 12 weeks.
         */
        let frequency = null;

        const allPlans = {
          739120415104: 4,
          739120447872: 8,
          739120480640: 12,

          739120513408: 4,
          739120546176: 8,
          739120578944: 12,

          739059728768: 4,
          739059761536: 8,
          739059827072: 12,

          739062251904: 4,
          739062284672: 8,
          739062317440: 12
        };

        frequency = allPlans[currentSellingPlan];

        if (!frequency) return;

        /*
         * Select the correct plan based on quantity.
         */
        const quantityRules = item.quantity > 1
          ? rules.moreThanOne
          : rules.one;

        const correctSellingPlan = quantityRules[frequency];

        if (!correctSellingPlan) return;

        /*
         * Only update if the current plan is different.
         */
        if (String(currentSellingPlan) !== String(correctSellingPlan)) {
          updates.push({
            line: item.key,
            quantity: item.quantity,
            selling_plan: correctSellingPlan
          });
        }
      });

      if (!updates.length) {
        console.log('Selling plans are already correct.');
        return;
      }

      /*
       * Update each affected cart line.
       */
      return Promise.all(
        updates.map(update => {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: update.line,
              quantity: update.quantity,
              selling_plan: update.selling_plan
            })
          });
        })
      );
    })
    .then(() => {
      console.log('Cart selling plans updated.');
       refreshCartDrawer();
    })
    .catch(error => {
      console.error('Error updating selling plans:', error);
    });
}